<script>
	module.exports = {
		data() {
			return {
				title: 'Data Breach Plan for ReadWorks'
			};
		}
	};
</script>
<template>
	<main
		id="content"
		class="main data-breach-plan">
		<header class="margin-top-medium">
			<div class="wrapper">
				<h1 class="main-header-title">Data Breach Plan for ReadWorks</h1>
			</div>
		</header>
		<section class="main-content wrapper rte">
			<p>
				ReadWorks has designated a Privacy Officer to monitor and oversee data policies and procedures. They will monitor cybersecurity threats,
				vulnerabilities and legal updates regularly as well as update software to provide further security.
			</p>

			<p>
				This Privacy Officer will also train employees regarding ReadWorks’ procedures and policies surrounding data confidentiality. They will ensure
				trained employees only have access to sensitive data when necessary.
			</p>

			<p>
				In the first 24 hours after discovering any signs of a data breach, the Privacy Team will alert and activate everyone at ReadWorks. The team will
				ensure the area where the data breach occurred is secure to help preserve evidence and stop additional data loss. The Privacy Team will document
				who discovered the breach, who reported it and what type of breach occurred. They will interview all involved parties and document the results.
				With this information, they will ascertain what data has been compromised and what parties are affected by the breach.
			</p>

			<p>
				ReadWorks employees will then prepare external communications regarding the incident to reach out to the exposed parties in accordance with
				applicable laws and regulations.
			</p>

			<p>
				After a breach, trained employees, along with the Privacy Officer, will fix all issues that led to the incident in order to prevent further
				unauthorized access. They will also preserve any relevant evidence regarding the situation to further investigate and analyze the cause of said
				data breach.
			</p>
		</section>
	</main>
</template>
